import { render, staticRenderFns } from "./BButtonRequest.vue?vue&type=template&id=c237cec8&"
import script from "./BButtonRequest.vue?vue&type=script&lang=js&"
export * from "./BButtonRequest.vue?vue&type=script&lang=js&"
import style0 from "./BButtonRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports